import { render, staticRenderFns } from "./GameCreator.vue?vue&type=template&id=8a965846&scoped=true"
import script from "./GameCreator.vue?vue&type=script&lang=js"
export * from "./GameCreator.vue?vue&type=script&lang=js"
import style0 from "./GameCreator.vue?vue&type=style&index=0&id=8a965846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a965846",
  null
  
)

export default component.exports